import { render, staticRenderFns } from "./dorm.vue?vue&type=template&id=442d537a&"
import script from "./dorm.vue?vue&type=script&lang=js&"
export * from "./dorm.vue?vue&type=script&lang=js&"
import style0 from "./dorm.vue?vue&type=style&index=0&id=442d537a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports